import type {
    PostRegisterAdditionalInfoPayload,
    PostRegisterAdditionalInfoRequest,
    PostRegisterAdditionalInfoResponse,
} from './types';

import { postGenericEndpoint, type PostGenericEndpointParams } from './post.api';

const toPayload = (
    data: PostRegisterAdditionalInfoRequest,
): PostRegisterAdditionalInfoPayload => ({
    fields: data.fields
        .filter((field) => field.value.length > 0)
        .map((field) => ({
            alias: field.alias,
            value: field.value,
        })),
});

export const postRegisterAdditionalInfo = async (
    {
        data,
        lang,
        token,
    }: PostGenericEndpointParams<PostRegisterAdditionalInfoRequest>,
) => {
    return await postGenericEndpoint<
        PostRegisterAdditionalInfoPayload,
        PostRegisterAdditionalInfoResponse
    >({
        data: toPayload(data),
        lang,
        token,
        path: 'register/additional-info',
    });
};
